import { useState } from "react";

interface AccordionItemProps {
  question: string;
  answer: string;
  isLast?: boolean;
}

export default function AccordionItem({ question, answer, isLast }: AccordionItemProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${!isLast ? "border-b border-gray-100" : ""}`}>
      <button
        className="flex items-center justify-between w-full px-4 py-3.5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span className="text-gray-800 font-medium text-sm">{question}</span>
        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-2 bg-gray-100 rounded-full">
          <i className={`ri-arrow-down-s-line text-gray-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`}></i>
        </div>
      </button>
      {open && (
        <div className="px-4 pb-4 text-gray-500 text-sm leading-relaxed">
          <p dangerouslySetInnerHTML={{ __html: answer }} />
        </div>
      )}
    </div>
  );
}
